"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const as_sha256_1 = require("@chainsafe/as-sha256");
function hash(a, b) {
    return as_sha256_1.default.digest(Buffer.concat([a, b]));
}
exports.hash = hash;
